<div *ngIf="isAllowed" class="container">
  <div class="vehicle-report">
    <div class="scroll-wrapper">
      @if (dealerImageDetails?.url) {
      <div class="image-container">
        <img [src]="dealerImageDetails?.url" alt="File not found" i18n-alt />
      </div>
      }
      @if (isLargeScreen) {
      <div class="auth-section">
        <app-proforma-invoice-auth [apiResponse]="apiResponse" [pdfBase64Data]="pdfBase64Data"
          [isPDFDataAvailable]="isPDFDataAvailable" (startusChange)="updateApprovalStatus($event)">
        </app-proforma-invoice-auth>
      </div>
      }
    </div>

    <mat-card class="report-card">
      @if (apiResponse) {
      <div class="report-header">
        <mat-card-title i18n>Proforma Service Invoice</mat-card-title>
      </div>
      }

      <div class="section vehicle-info-section">
        <div class="vehicle-data">
          <p class="title">
            {{ apiResponse?.vehicle?.make }} {{ apiResponse?.vehicle?.model }}
          </p>
          <p class="subtitle" i18n>
            {{ apiResponse?.vehicle?.licenseNo }} |
            {{ apiResponse?.vehicle?.mileage }}
            @if (apiResponse?.vehicle?.mileage) {
            <span>miles</span>
            }
          </p>
        </div>
      </div>

      <div class="section vehicle-info-section">
        <div class="info-row">
          <div class="text-group">
            <p class="title" i18n>Invoice {{ apiResponse?.invoiceNo }}</p>
            <p i18n>{{ apiResponse?.postingDate | date: 'dd.MM.yy' }}</p>
          </div>

          <div class="action-buttons">
            <button class="download-button" mat-mini-fab color="primary" [disabled]="isDownloading"
               [matTooltip]="downloadPdfreport" (click)="downloadPdf()">
              @if (!isDownloading && !downloadCompleted) {
              <img #downloadPDFTour class="download-icon" src="../../assets/common/download-tray.svg"
                alt="File not found." i18n-alt />
              }

              @if (isDownloading) {
              <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
              }

              @if (downloadCompleted) {
              <mat-icon class="completed-icon">check</mat-icon>
              }
            </button>

            <button class="chevron-right" mat-mini-fab color="primary" (click)="navigateToproformaInvoiceDetails()"
              (keydown.enter)="navigateToproformaInvoiceDetails()">
              <div #authInvoice>
                <mat-icon>chevron_right</mat-icon>
              </div>
            </button>
          </div>
        </div>

        <mat-divider></mat-divider>

        @if (isAuthorized)
        {
        <p class="proformaAuthorizedLink" i18n>Authorized</p>
        }
        @else
        {
        @if (isLargeScreen)
        {
        <a class="proformaPendingLink" i18n>Pending</a>
        }
        @else
        {
        <a class="proformaPendingLink" (click)="navigateToproformaInvoiceDetails()" i18n>Pending</a>
        }
        }
      </div>
    </mat-card>

  </div>
</div>